import React from "react";
import { IconButton, Box } from "@mui/material";
import { Undo, Redo } from "@mui/icons-material";

const UndoRedoComponent = ({
  handleUndo = () => {},
  handleRedo = () => {},
  canUndo = false,
  canRedo = false,
}) => {
  return (
    <Box>
      <IconButton color="info" onClick={handleUndo} disabled={!canUndo}>
        <Undo />
      </IconButton>
      <IconButton color="info" onClick={handleRedo} disabled={!canRedo}>
        <Redo />
      </IconButton>
    </Box>
  );
};

export default UndoRedoComponent;
